<template>
    <div v-if="!accept" class="p-5">
      Bạn chưa được phép xem trang này!
    </div>
    <div v-else>
      <h1>Sản phẩm</h1>

      <b-tabs content-class="mt-3">
        <b-tab title="Thông tin sản phẩm" active>
          <div class="mobile-button-group mb-3">
            <b-button variant="primary" @click="gotoPosting" class="mobile-button" v-if="isAdmin || editable">Đăng tin</b-button>
            <b-button variant="primary" @click="gotoEdit" class="mobile-button" v-if="isAdmin || editable">Sửa nội dung</b-button>
            <b-button variant="primary" @click="generateNewProductID" class="mobile-button mobile-button-long" v-if="isAdmin || editable">Sinh mã sản phẩm mới</b-button>
          </div>
          <hr/>

          <generic-detail-view
              rootPath="/v2/products"
              :forms="forms"
              :columns="columns"
              :table_name="table_name"
              :service="service"
              >

          </generic-detail-view>
        </b-tab>

        <b-tab title="Lịch sử giao dịch" v-if="isAdmin || can_see_sensitive_customer_data">
          <p v-if="!isAdmin">Đang phát triển</p>
          <product-transaction-list v-bind:productId="$route.params.id" v-if="isAdmin">
          </product-transaction-list>
        </b-tab>

        <b-tab title="Tìm Khách Hàng" v-if="isAdmin || can_see_sensitive_customer_data">
          <p v-if="!isAdmin">Đang phát triển</p>
          <client-suggestion v-bind:productId="$route.params.id" v-if="isAdmin">
          </client-suggestion>

        </b-tab>
      </b-tabs>

        
<!--         
        <div class="row" v-if="isLoading">
            Loading...
        </div> -->
        
    </div>

</template>

<script>
import TableMeta from '@/models/ProductTableMeta'
import GenericDetailView from '@/views/base/GenericDetailView'
import ProductService from '@/services/productService'
import ProductTransactionList from '@/module-product-transactions/ProductTransactionList'
import ClientSuggestion from '@/module-client-suggestion/ClientSuggestion'

export default {
  name: 'ProductViewDetail',
  components: {
      'generic-detail-view': GenericDetailView,
      'product-transaction-list': ProductTransactionList,
      'client-suggestion': ClientSuggestion
    },
  data () {
    return {
        forms: TableMeta.input_view.forms,
        columns: TableMeta.columns,
        table_name: TableMeta.table_name,
        created_by: ''
    }
  },
  computed: {
    service () {
      return new ProductService(TableMeta.table_name);
    },
    accept() {
      // if (this.$store.getters.role == 'ctv') {
      //   return false;
      // }
      return true;
    },
    isAdmin() {
      if (this.$store.getters.role == 'admin') {
        return true;
      }
      return false;
    },
    editable () {
      if ( 
        (this.$store.getters.permissions && this.$store.getters.permissions['product_input']) 
        || (this.$store.getters.userEmail === this.created_by)
      )
      {
        return true;
      }

      return false;
    },
    can_see_sensitive_customer_data () {
      if (this.$store.getters.role == 'admin' 
        || (this.$store.getters.permissions && this.$store.getters.permissions['product_sensitive_data'])
        || (this.$store.getters.userEmail === this.created_by)
      )
      {
        return true;
      }

      return false;
    }
  },
  methods: {
    gotoPosting () {
        var id = this.$route.params.id;
        console.log('id: ' + id);
        this.$router.push({path: `/v2/products/${id}/posting`});
    },

    gotoEdit () {
      var id = this.$route.params.id;
      this.$router.push({path: `/v2/products/${id}`});
    },

    async generateNewProductID () {
      var id = this.$route.params.id;

      var service = new ProductService();
      var productDetail = await service.getDetail(id);
      console.log(productDetail);

      var new_product_code = await service.generateNewProductCode(productDetail);

      var answer = confirm('Mã sp sẽ được đổi từ ' + productDetail.code +' sang mã mới ' + new_product_code + '. Bạn có muốn cập nhật ko?');
      console.log(answer);
      if(answer) {

        try {
          await service.updateProductColumn(productDetail.id, 'code', new_product_code, 'text');
          this.$router.go();
        }
        catch (err) {
          alert(err);
        }
      }

      
    },

    async refresh () {
      var id = this.$route.params.id;
      var service = new ProductService();
      var productDetail = await service.getDetail(id);
      this.created_by = productDetail.created_by;
    }
  },
  mounted () {
    this.refresh();
  }
}
</script>

<style scoped>
.mobile-button-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.mobile-button {
  margin: 0;
  white-space: nowrap;
}

/* Mobile styles */
@media (max-width: 768px) {
  .mobile-button-group {
    flex-direction: column;
    align-items: stretch;
  }
  
  .mobile-button {
    width: 100%;
    margin-bottom: 8px;
    font-size: 0.9rem;
  }
  
  .mobile-button-long {
    font-size: 0.85rem;
  }
  
  /* Improve tab content spacing on mobile */
  .tab-content {
    padding: 0 8px;
  }
  
  /* Better heading styles for mobile */
  h1 {
    font-size: 1.5rem;
    text-align: center;
    margin-bottom: 1rem;
  }
}

/* Tablet styles */
@media (min-width: 769px) and (max-width: 992px) {
  .mobile-button {
    font-size: 0.9rem;
  }
  
  .mobile-button-long {
    font-size: 0.85rem;
  }
}
</style>

